import { render } from "./AcceptOffer.vue?vue&type=template&id=3e0a8bed&scoped=true"
import script from "./AcceptOffer.vue?vue&type=script&lang=js"
export * from "./AcceptOffer.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyNft.scss?vue&type=style&index=0&id=3e0a8bed&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0a8bed"]])

export default __exports__